import axios from 'axios'
import { Form } from './contactoM'

const api = "https://webhooks.mongodb-realm.com/api/client/v2.0/app/comercialamaroweb-grsdi/service/CaS/incoming_webhook/"

export const postForm = async(form : Form) => {
    return await axios.post(`${api}CaFormPost`, form)
}